import api from "../../index";

export const GetOrganizerListApi = (data) => api.post('clientfilelist', data);
export const CreateChatApi = (data) => api.post('chatcreate', data);
export const GetActiveChatApi = () => api.post('chatroomsbydate');
export const GetArchiveChatApi = () => api.post('archivechatlist');
export const GetMessageListApi = (data) => api.post('chatmessageslist', data);